import { sb } from '../supabase.ts';

export async function renderRegDashboardPage(app: HTMLElement) {
  app.innerHTML = `
<style>
  .reg-wrap { background: #f8fafc; min-height: 100vh; padding: 32px; }
  .grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(280px, 1fr)); gap: 24px; margin-bottom: 32px; }
  .stat-card { background: #fff; padding: 24px; border-radius: 16px; border: 1px solid #e2e8f0; box-shadow: 0 4px 6px -1px rgba(0,0,0,0.05); }
  .stat-card h3 { font-size: 14px; font-weight: 700; color: #64748b; text-transform: uppercase; margin: 0 0 12px 0; letter-spacing: 0.05em; }
  .stat-card .value { font-size: 32px; font-weight: 800; color: #1e293b; }
  .stat-card .sub { font-size: 13px; color: #10b981; margin-top: 8px; font-weight: 600; }

  .card { background: #fff; border-radius: 16px; border: 1px solid #e2e8f0; padding: 24px; margin-bottom: 24px; }
  .card h2 { font-size: 18px; font-weight: 700; color: #1e293b; margin-bottom: 20px; }

  .class-table { width: 100%; border-collapse: collapse; }
  .class-table th { text-align: left; padding: 12px; border-bottom: 2px solid #f1f5f9; color: #475569; font-size: 12px; text-transform: uppercase; }
  .class-table td { padding: 12px; border-bottom: 1px solid #f1f5f9; font-size: 14px; }
  
  .progress-bar { height: 8px; background: #f1f5f9; border-radius: 4px; overflow: hidden; margin-top: 8px; }
  .progress-fill { height: 100%; background: var(--primary); border-radius: 4px; }

  .loading-overlay { text-align: center; padding: 60px; color: #64748b; }
</style>

<div class="reg-wrap">
  <div class="container">
    <!-- Quick Actions Card -->
    <div class="card" style="margin-bottom: 24px; background: #fff; border-radius: 16px; border: 1px solid #e2e8f0; padding: 24px;">
      <h2>Registration Quick Actions</h2>
      <div style="display: flex; gap: 16px; flex-wrap: wrap;">
        <a href="/reg_form/6_reg_list.html?class=6" target="_blank" style="text-decoration: none; padding: 14px 24px; background: #3b82f6; color: white; border-radius: 10px; font-weight: 600; display: inline-flex; align-items: center; gap: 8px; transition: transform 0.2s; box-shadow: 0 4px 6px -1px rgba(59,130,246,0.2);">
          <span>📝</span> Class 6 Reg List
        </a>
        <a href="/reg_form/6_reg_list.html?class=9" target="_blank" style="text-decoration: none; padding: 14px 24px; background: #ec4899; color: white; border-radius: 10px; font-weight: 600; display: inline-flex; align-items: center; gap: 8px; transition: transform 0.2s; box-shadow: 0 4px 6px -1px rgba(236,72,153,0.2);">
          <span>🎓</span> Class 9 Reg List
        </a>
        <a href="/reg_form/reg_dashboard.html" target="_blank" style="text-decoration: none; padding: 14px 24px; background: #1e293b; color: white; border-radius: 10px; font-weight: 600; display: inline-flex; align-items: center; gap: 8px; transition: transform 0.2s; box-shadow: 0 4px 6px -1px rgba(30,41,59,0.2);">
          <span>🎛️</span> Reg Dashboard HTML
        </a>
      </div>
    </div>

    <div class="grid">
      <div class="stat-card">
        <h3>Total Registered Students</h3>
        <div class="value" id="totalReg">...</div>
        <div class="sub">Students with IID assigned</div>
      </div>
      <div class="stat-card">
        <h3>Session 2025</h3>
        <div class="value" id="total2025">...</div>
        <div class="sub">Active in current session</div>
      </div>
      <div class="stat-card">
        <h3>Pending Sync</h3>
        <div class="value" id="totalPending">...</div>
        <div class="sub" style="color:#f59e0b;">Records needing active update</div>
      </div>
    </div>

    <div class="card">
      <h2>Registration by Class (2025)</h2>
      <div id="classBreakdown">
        <div class="loading-overlay">Loading statistics...</div>
      </div>
    </div>
  </div>
</div>
  `;

  async function loadStats() {
    const totalRegEl = document.getElementById('totalReg')!;
    const total2025El = document.getElementById('total2025')!;
    const totalPendingEl = document.getElementById('totalPending')!;
    const breakdownEl = document.getElementById('classBreakdown')!;

    const { count: total } = await sb.from('student_database').select('*', { count: 'exact', head: true });
    const { count: total25 } = await sb.from('student_database').select('*', { count: 'exact', head: true }).not('class_2025', 'is', null);
    
    // Quick approximation for pending sync (students where active_class != class_2025)
    // Note: Supabase doesn't support complex cross-column comparison in a single simple count query easily without RPC
    // So we'll fetch a sample or just show 2025 total as potential sync targets
    
    totalRegEl.textContent = total?.toString() || '0';
    total2025El.textContent = total25?.toString() || '0';
    totalPendingEl.textContent = 'Calculated...';

    const classes = ['6', '7', '8', '9', '10'];
    const stats: any[] = [];

    for (const c of classes) {
      const { count } = await sb.from('student_database')
        .select('*', { count: 'exact', head: true })
        .eq('class_2025', c);
      stats.push({ name: c, count: count || 0 });
    }

    totalPendingEl.textContent = stats.reduce((a, b) => a + b.count, 0).toString();

    const max = Math.max(...stats.map(s => s.count));

    breakdownEl.innerHTML = `
      <table class="class-table">
        <thead>
          <tr>
            <th>Class</th>
            <th>Count</th>
            <th>Distribution</th>
          </tr>
        </thead>
        <tbody>
          ${stats.map(s => `
            <tr>
              <td style="font-weight:600;">Class ${s.name}</td>
              <td>${s.count}</td>
              <td style="width:50%;">
                <div style="font-size:12px; margin-bottom:4px; color:#64748b;">${Math.round((s.count/total25!)*100)}%</div>
                <div class="progress-bar">
                  <div class="progress-fill" style="width: ${(s.count / max) * 100}%"></div>
                </div>
              </td>
            </tr>
          `).join('')}
        </tbody>
      </table>
    `;
  }

  loadStats();
}
